/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

import { BUSINESS_STATUSES } from '@/lib/consts.js'

import { replaceWithResolvedRoute } from '../utils/replace-with-resolved-route'

import type { RedirectContext } from '../types'

export const onboardingRedirect = ({ query, params, store, router, logger }: RedirectContext): unknown => {
  if (!store.state.identity.user) {
    logger.debug('no user! >>> onboarding')
    return replaceWithResolvedRoute(router, { name: 'onboarding', query, params })
  }

  if (!store.getters['business/business']) {
    logger.debug('no business! >>> onboarding')
    return replaceWithResolvedRoute(router, { name: 'onboarding', query, params })
  }

  if (store.getters['business/businessStatus'] === BUSINESS_STATUSES.SETUP) {
    logger.debug('business in setup mode! >>> onboarding')
    return replaceWithResolvedRoute(router, { name: 'onboarding', query, params })
  }
}
